import { PartnerTypes } from 'apis/PartnerApi';

export type ScopeType = 'none' | 'self' | 'partner' | 'student';

export const getScopeType = (scopeId: number | null | undefined): ScopeType => {

    switch (scopeId) {

        case 1: return 'self';
        case 2:
        case 4: return 'partner';
        case 8:
        case 10: return 'student';
        default: return 'none';

    }

};

export const scopeNameFor = (scopeId: number | null | undefined): string => {

    switch (scopeId) {

        case 1: return 'System';
        case 2: return 'Distributor';
        case 3: return 'Reseller';
        case 4: return 'Testing Center';
        case 5: return 'Author';
        case 6: return 'Instructor';
        case 7: return 'Association';
        case 8: return 'Student';
        case 9: return 'Test';
        case 10: return 'Test Result';
        default: return `Unknown (${scopeId})`;

    }

};

export const isSuperAdminRole = (highestRoleId: number | null | undefined): boolean => highestRoleId === PartnerTypes.SuperAdmin;

// Associations own no testing centers directly, so they must pick one of their member testing centers.
const isAssociationTestingCenterScope = (scopeId: number, highestRoleId: number): boolean =>
    scopeId === PartnerTypes.TestingCenter && highestRoleId === PartnerTypes.Association;

export const needsPartnerPicker = (scopeId: number, highestRoleId: number): boolean =>
    getScopeType(scopeId) === 'partner' && (isSuperAdminRole(highestRoleId) || isAssociationTestingCenterScope(scopeId, highestRoleId));

export const needsStudentPicker = (scopeId: number): boolean => getScopeType(scopeId) === 'student';
